import React from 'react';
import {Col} from 'react-bootstrap';

const FeaturesContent = (props) => {
    return (
        <Col md={4} sm={6} xs={12} className="single-feature">
            <div data-aos="fade-up" data-aos-duration="1500">
                <img src={props.image} alt="affordable image" />
                <p className="feature-heading">{props.title}</p>
                <section className="feature-heading-divider my-3"></section>
                <p>{props.content}</p>
            </div>
        </Col>
    )
}

export default FeaturesContent
